module.exports = __webpack_public_path__ + "img/6.665de28b.jpeg";